<div>
    <div class="page-header">
        <h1 class="page-title">{{title}}</h1>
    </div>
    <ng-content></ng-content>
</div>
